@if (!edit){
<div class="d-flex w-100 profile-detail-row">
  <p>
    {{ title | translate }}
  </p>
  <span>{{ (control.value ? 'shared.yes' : 'shared.no') | translate }}</span>
</div>
} @else {
<div class="p-0 m-0 w-100">
  <p class="rightHeadings">
    {{ title | translate }}
    @if(required){<span class="text-danger">*</span>}
  </p>
  <div data-multiselect class="d-flex flex-column">
    <input hidden="true" matInput />
    <mat-checkbox [formControl]="control" class="button-like"> </mat-checkbox>
  </div>
</div>
}
